import React from 'react'

import PageHeader from '../components/page-header'
import TitleContent from '../components/title-content'
import Image from '../components/image'
import FourColumnContent from '../components/four-column-content'
import LargeContent from '../components/large-content'
import Partners from '../components/partners'
import PageLinks from '../components/page-links'
import LatestMedia from '../components/latest-media'
import TitleContentCta from '../components/title-content-cta'
import ContactMap from '../components/contact-map'
import ContactDetails from '../components/contact-details'
import ContactForm from '../components/contact-form'
import ThankYou from '../components/thank-you'
import Landing from '../components/landing'
import Projects from '../components/projects'
import Media from '../components/media'
import Home from '../components/home'

const renderBlock = (param, el, i) => {

  el.key = i

  let block = {
    'PageHeader' : (el) => <PageHeader {...el} />,
    'TitleContent' : (el) => <TitleContent {...el} />,
    'Image' : (el) => <Image {...el} />,
    'FourColumnContent' : (el) => <FourColumnContent {...el} />,
    'LargeContent' : (el) => <LargeContent {...el} />,
    'Partners' : (el) => <Partners {...el} />,
    'PageLinks' : (el) => <PageLinks {...el} />,
    'LatestMedia' : (el) => <LatestMedia {...el} />,
    'TitleContentCta' : (el) => <TitleContentCta {...el} />,
    'ContactMap' : (el) => <ContactMap {...el} />,
    'ContactDetails' : (el) => <ContactDetails {...el} />,
    'ContactForm' : (el) => <ContactForm {...el} />,
    'ThankYou' : (el) => <ThankYou {...el} />,
    'Landing' : (el) => <Landing {...el} />,
    'Home' : (el) => <Home {...el} />,
    'Projects' : (el) => <Projects {...el} />,
    'Media': (el) => <Media {...el} />,
  }[param]

  if (!block) return null

  return block(el)
}

export default renderBlock
